<template>
    <div>
        <!-- Documento de Pré-Atendimento -->
        <div class="modal fade" id="autPreAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documento de Pré-Atendimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <div v-else>
                            <div class="alert alert-info">
                                <template v-if="solic.paciente">
                                    <div>{{ solic.paciente.st_nome }}</div>
                                    <div v-if="solic.paciente.cadastro">{{ solic.paciente.cadastro.st_email }}</div>
                                </template>

                                <template v-else>
                                    <div>{{ solic.cadastro_temporario.st_nome }}</div>
                                    <div>{{ solic.cadastro_temporario.st_email }}</div>
                                </template>

                                <hr>

                                <div>{{ solic.procedimento.search }}</div>
                            </div>

                            <ul class="list-group" v-if="dados && dados.length">
                                <li class="list-group-item" v-for="(doc, idx) in dados" :key="idx">
                                    {{ doc.st_modelo_prontuario }}
                                </li>
                            </ul>

                            <div class="alert alert-warning" v-else>
                                Nenhum formulário configurado para envio para esse procedimento.
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="enviar()" :disabled="!dados || !dados.length">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: null, 
            marcacao: null, 
            solic: null, 
        }
    },

    components: { 
        AzEmptyState, 
        AzSubmit, 
    },

    methods: { 
        enviar () { 
            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'enviar_email',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao, 
                },
                modal: 'autPreAtendimentoModal',
                toast: true, 
                msg: 'Mensagem enviada.'
            });
        },

        abrir(marcacao, solic) { 

            this.solic = solic;
            this.marcacao = marcacao;
            this.dados = null;

            this.$store.commit('loading', true);

            $('#autPreAtendimentoModal').modal('show');

            this.$util.loadItem(this, { 
                service: 'documentos_pre_atendimento', 
                func: 'lista', 
                parms: { 
                    id_marcacao: marcacao.id_marcacao, 
                    pre_cadastro: true, 
                }
            })
            .then(res => { 
                this.dados = res;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        }
    }
}
</script>